export { Compare } from './compare';
